module.exports = __webpack_public_path__ + "img/onlineExpo_chat.d14667fc.png";